import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import moment from "moment";
import { ApexOptions } from "apexcharts";
import { useDispatch, useSelector } from "react-redux";
import {
  getMyOrganization,
  getReadingList,
  getSubject,
} from "@src/redux";
import { startCase } from "lodash";
import { Skeleton } from "antd";

const SubjectReadingDetailsGraph: React.FC = () => {
  const { result: readingList, loading: readingListLoading } =
    useSelector(getReadingList);
  const { result: subject } = useSelector(getSubject);
  const [redingList, setRedingList] = useState<any[]>([]);
  const { result: organization } = useSelector(getMyOrganization);
  const getVitalColorCode = (color: string) => {
    var colorCode = "#ccd4de";
    if (color) {
      // Strip whitespace AND underscores so "dark_red"/"dark red" both match
      // the "darkred" case below (was previously only stripping one space, so
      // critical readings rendered with the default grey on the graph).
      color = color.replace(/[\s_]+/g, "");
      color = color.toLowerCase();
    }

    switch (color) {
      case "green":
        colorCode = "#4dad4d";
        break;
      case "orange":
        colorCode = "#f3bc56";
        break;
      case "red":
        colorCode = "#e98c8c";
        break;
      case "yellow":
        colorCode = "#c3c33d";
        break;
      case "darkred":
        colorCode = "#b15c5c";
        break;
      default:
        colorCode = "#ccd4de";
        break;
    }
    return colorCode;
  };
  useEffect(() => {
    if (readingList?.items && readingList?.items?.length > 0) {
      setRedingList(readingList?.items);
    } else {
      setRedingList([]);
    }
  }, [readingList]);

  let OrganizationType = startCase(organization?.type) || "  ";

  let markerData: any = [];
  let pulseData: any = [];
  let skinData: any = [];
  let spo2Data: any = [];
  let rrData: any = [];
  let systolicData: any = [];
  let diastolicData: any = [];
  let meanData: any = [];
  let randomSugarData: any = [];
  let fastingSugarData: any = [];
  let ppSugarData: any = [];
  let bmiData: any = [];
  // let ewsData:any = [];
  let pulseRateIndex: any = 0;
  let skinIndex: any = 0;
  let spo2Index: any = 0;
  let rrIndex: any = 0;
  let systolicIndex: any = 0;
  let diastolicIndex: any = 0;
  let randomSugarIndex: any = 0;
  let fastingSugarIndex: any = 0;
  let ppSugarIndex: any = 0;
  let bmiIndex: any = 0;
  let ewsIndex: any = 0;
  let dates: any = [];

  let pulseSeriesIndex: any = 0;
  let skinSeriesIndex: any = 1;
  let o2SeriesIndex: any = 2;
  let rrSeriesIndex: any = 3;
  let systolicSeriesIndex: any = 4;
  let diastolicSeriesIndex: any = 5;
  let randomSugarSeriesIndex: any = 6;
  let fastingSugarSeriesIndex: any = 7;
  let ppSugarSeriesIndex: any = 8;
  let bmiSeriesIndex: any = 9;

  let meanSeriesIndex: any = 6;
  let sugarSeriesIndex: any = 7;
  let ewsSeriesIndex: any = 8;

  for (let i = 0; i < redingList?.length; i++) {
    let item = redingList[i];
    let dateTime = new Date(item?.datetime).getTime();
    let hasData = false;
    if (item.vincenseReading?.pulseValue) {
      hasData = true;
      pulseData.push([dateTime, item?.vincenseReading?.pulseValue]);
      markerData.push({
        seriesIndex: pulseSeriesIndex,
        dataPointIndex: pulseRateIndex,
        fillColor:
          item?.vincenseReading?.pulseColor &&
          getVitalColorCode(item?.vincenseReading?.pulseColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      pulseRateIndex++;
    }
    if (item.vincenseReading?.skinValue) {
      hasData = true;
      skinData.push([dateTime, item.vincenseReading?.skinValue]);
      markerData.push({
        seriesIndex: skinSeriesIndex,
        dataPointIndex: skinIndex,
        // fillColor: getVitalColorCode(item.vincenseReading?.skinValue),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      skinIndex++;
    }
    if (item.vincenseReading?.o2Value) {
      hasData = true;
      spo2Data.push([dateTime, item.vincenseReading?.o2Value]);
      markerData.push({
        seriesIndex: o2SeriesIndex,
        dataPointIndex: spo2Index,
        fillColor:
          item.vincenseReading?.o2Color &&
          getVitalColorCode(item.vincenseReading?.o2Color),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      spo2Index++;
    }
    if (item.vincenseReading?.rrValue) {
      hasData = true;
      rrData.push([dateTime, item.vincenseReading?.rrValue]);
      markerData.push({
        seriesIndex: rrSeriesIndex,
        dataPointIndex: rrIndex,
        fillColor:
          item.vincenseReading?.rrColor &&
          getVitalColorCode(item.vincenseReading?.rrColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      rrIndex++;
    }
    if (item.bpReading?.systolicValue) {
      hasData = true;
      systolicData.push([dateTime, item.bpReading?.systolicValue]);
      markerData.push({
        seriesIndex: systolicSeriesIndex,
        dataPointIndex: systolicIndex,
        fillColor:
          item.bpReading?.systolicColor &&
          getVitalColorCode(item.bpReading?.systolicColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      systolicIndex++;
    }
    if (item.bpReading?.diastolicValue) {
      hasData = true;
      diastolicData.push([dateTime, item.bpReading?.diastolicValue]);
      markerData.push({
        seriesIndex: diastolicSeriesIndex,
        dataPointIndex: diastolicIndex,
        fillColor:
          item.bpReading?.diastolicColor &&
          getVitalColorCode(item.bpReading?.diastolicColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      diastolicIndex++;
    }
    if (item.bpReading?.meanValue) {
      hasData = true;
      meanData.push([dateTime, item.bpReading?.meanValue]);
      markerData.push({
        seriesIndex: meanSeriesIndex,
        dataPointIndex: diastolicIndex,
        fillColor:
          item.bpReading?.meanColor &&
          getVitalColorCode(item.bpReading?.meanColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      diastolicIndex++;
    }
    if (item.glucometerReading?.randomValue) {
      hasData = true;
      randomSugarData.push([dateTime, item.glucometerReading?.randomValue]);
      markerData.push({
        seriesIndex:
          // OrganizationType === "Screening"
          //   ? randomSugarSeriesIndex
          //   : sugarSeriesIndex,
          sugarSeriesIndex,
        dataPointIndex: randomSugarIndex,
        fillColor:
          item.glucometerReading?.randomColor &&
          getVitalColorCode(item.glucometerReading?.randomColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      randomSugarIndex++;
    }
    if (item.glucometerReading?.fastingValue) {
      hasData = true;
      fastingSugarData.push([dateTime, item.glucometerReading?.fastingValue]);
      markerData.push({
        seriesIndex: fastingSugarSeriesIndex,
        dataPointIndex: fastingSugarIndex,
        fillColor:
          item.glucometerReading?.fastingColor &&
          getVitalColorCode(item.glucometerReading?.fastingColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      fastingSugarIndex++;
    }
    if (item.glucometerReading?.ppValue) {
      hasData = true;
      ppSugarData.push([dateTime, item.glucometerReading?.ppValue]);
      markerData.push({
        seriesIndex: ppSugarSeriesIndex,
        dataPointIndex: ppSugarIndex,
        fillColor:
          item.glucometerReading?.ppColor &&
          getVitalColorCode(item.glucometerReading?.ppColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      ppSugarIndex++;
    }
    if (item.weighingReading?.bmiValue) {
      hasData = true;
      bmiData.push([dateTime, item.weighingReading?.bmiValue]);
      markerData.push({
        seriesIndex: bmiSeriesIndex,
        dataPointIndex: bmiIndex,
        fillColor:
          item.weighingReading?.bmiColor &&
          getVitalColorCode(item.weighingReading?.bmiColor),
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      });
      bmiIndex++;
    }
    // if (item.ews_reading) {
    //   hasData = true;
    //   ewsData.push([dateTime, item.EWS?.EWS.Score]);
    //   markerData.push({
    //     seriesIndex: ewsSeriesIndex,
    //     dataPointIndex: ewsIndex,
    //     fillColor: getVitalColorCode(item.EWS?.EWS.Color),
    //     strokeColor: "#fff",
    //     size: 5,
    //     shape: "circle",
    //   });
    //   ewsIndex++;
    // }
    if (hasData) {
      if (dates.indexOf(dateTime) === -1) dates.push(dateTime);
    }
  }
  let minDate = 0;
  let maxDate = 0;
  if (dates.length > 0) {
    maxDate = dates[dates.length - 1];
    let minIndex = dates.length > 10 ? dates.length - 11 : 0;
    minDate = dates[minIndex];
  }

  const optionsLine: any = {
    chart: {
      id: "chart1",
      height: 130,
      type: "area",
      brush: {
        target: "chart2",
        enabled: true,
      },
      selection: {
        enabled: true,
        xaxis: {
          min: minDate,
          max: maxDate,
        },
      },
    },
    colors: [
      "#4bc0c0",
      "#840101",
      "#cc33ff",
      "#fffe00",
      "#669900",
      "#e99002",
      "#cc3333",
      "#8236e6",
      "#004a0a",
      "#ff56cb",
    ],
    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0.91,
        opacityTo: 0.1,
      },
    },
    xaxis: {
      type: "datetime",
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      tickAmount: 2,
    },
    legend: {
      show: false,
    },
  };

  let seriesLine: any = [];
  if (OrganizationType === "Screening") {
    seriesLine = [
      {
        name: "Pulse Rate",
        data: pulseData,
      },
      {
        name: "Skin Temperature",
        data: skinData,
      },
      {
        name: "SpO2",
        data: spo2Data,
      },
      {
        name: "RR",
        data: rrData,
      },
      {
        name: "Systolic",
        data: systolicData,
      },
      {
        name: "Diastolic",
        data: diastolicData,
      },
      {
        name: "Random Sugar",
        data: randomSugarData,
      },
      {
        name: "Fasting Sugar",
        data: fastingSugarData,
      },
      {
        name: "PP Sugar",
        data: ppSugarData,
      },
      {
        name: "BMI",
        data: bmiData,
      },
    ];
  } else if (OrganizationType === "Monitoring") {
    seriesLine = [
      {
        name: "Pulse Rate",
        data: pulseData,
      },
      {
        name: "Skin Temperature",
        data: skinData,
      },
      {
        name: "SpO2",
        data: spo2Data,
      },
      {
        name: "RR",
        data: rrData,
      },
      {
        name: "Systolic",
        data: systolicData,
      },
      {
        name: "Diastolic",
        data: diastolicData,
      },
      {
        name: "Mean",
        data: meanData,
      },
      {
        name: "Sugar",
        data: randomSugarData,
      },
      // {
      //   name: "EWS",
      //   data: ewsData,
      // },
    ];
  }

  const options: ApexOptions = {
    chart: {
      id: "chart2",
      type: "line",
      height: 400,
      toolbar: {
        autoSelected: "pan",
        show: false,
      },
    },
    colors: [
      "#4bc0c0",
      "#840101",
      "#cc33ff",
      "#fffe00",
      "#669900",
      "#e99002",
      "#cc3333",
      "#8236e6",
      "#004a0a",
      "#ff56cb",
    ],
    stroke: {
      width: 2,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 1,
    },
    markers: {
      size: 5,
      discrete: markerData || [],
      hover: {
        size: 4,
        sizeOffset: 4,
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        formatter: function (value: string) {

          return [
            moment(new Date(value)).format("DD-MMM-yyyy"),
            moment(new Date(value)).format("hh:mm A"),
          ];
        },
      },
    },
  };
  let series: any = [];
  if (OrganizationType === "Screening") {
    series = [
      {
        name: "Pulse Rate",
        data: pulseData,
      },
      {
        name: "Skin Temperature",
        data: skinData,
      },
      {
        name: "SpO2",
        data: spo2Data,
      },
      {
        name: "RR",
        data: rrData,
      },
      {
        name: "Systolic",
        data: systolicData,
      },
      {
        name: "Diastolic",
        data: diastolicData,
      },
      {
        name: "Random Sugar",
        data: randomSugarData,
      },
      {
        name: "Fasting Sugar",
        data: fastingSugarData,
      },
      {
        name: "PP Sugar",
        data: ppSugarData,
      },
      {
        name: "BMI",
        data: bmiData,
      },
    ];
  } else if (OrganizationType === "Monitoring") {
    series = [
      {
        name: "Pulse Rate",
        data: pulseData,
      },
      {
        name: "Skin Temperature",
        data: skinData,
      },
      {
        name: "SpO2",
        data: spo2Data,
      },
      {
        name: "RR",
        data: rrData,
      },
      {
        name: "Systolic",
        data: systolicData,
      },
      {
        name: "Diastolic",
        data: diastolicData,
      },
      {
        name: "Mean",
        data: meanData,
      },
      {
        name: "Sugar",
        data: randomSugarData,
      },
      {
        name: "EWS",
        // data: ewsData,
      },
    ];
  }

  return (
    <div className="reading_subject_graph_container">
      <div className="subject-reading-details-graph">
        <div className="reading_analysis">{"Analysis"}</div>
        {readingListLoading ? (
          <Skeleton.Button active className="chart-skeleton-loading" />
        ) : (
          <>
            <Chart options={options} series={series} type="line" height={350} />
            <Chart
              options={optionsLine}
              series={seriesLine}
              type="area"
              height={200}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SubjectReadingDetailsGraph;
